import styled from 'styled-components';

import { colors, spacing } from 'ui/theme';

interface ContainerProps {
  isDnDOff?: boolean;
}

// disable Bee drag and drop interactions is isDnDOff is true
export const Container = styled.div<ContainerProps>`
  border-radius: ${spacing.quarter};
  border: ${spacing.single} solid ${colors.grey25};
  height: 100%;
  overflow: hidden;
  
  ${({ isDnDOff }) =>
    isDnDOff &&
    `
    iframe {
      pointer-events: none;
    }
  `}
`;
